(function ($) {
  $(function () {
    var $imageGrid = $('.image-grid');

    if ($imageGrid.length) {
      initCardGridSlider();

      $(window).on('resize', initCardGridSlider);

      function initCardGridSlider() {
        if (
          $(window).width() <= 1023 &&
          $imageGrid.find('.image-grid__box').length > 1 &&
          !$imageGrid.hasClass('slick-initialized')
        ) {
          $imageGrid.on('init', function() {
            $imageGrid.addClass('default-slick');
            $imageGrid.find('.image-grid__box').matchHeight();
          });

          $imageGrid.slick({
            infinite: false,
            swipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 1023,
                settings: 'unslick'
              },
            ],
          });
        } else {
          $imageGrid.removeClass('default-slick');
          $imageGrid.removeAttr('style');
        }
      }
    }
  });
})(jQuery);